import { IndustriesTable } from "@/components/IndustriesTable";

export function IndustriesPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-6 text-2xl font-bold">Industries</h1>
      <IndustriesTable />
    </div>
  );
}
